import React from "react";

const LineChangeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="3"
      height="16"
      viewBox="0 0 3 16"
      fill="none"
    >
      <path d="M1 0V6L2 8L1 10V16" stroke="#D0D5DD" />
    </svg>
  );
};

export default LineChangeIcon;
